import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Pagination.css';

const Pagination = ({ 
  currentPage = 1, 
  totalItems = 0, 
  itemsPerPage = 10, 
  onPageChange,
  showSummary = true
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  
  if (totalItems === 0) return null;

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button 
            key={i} 
            className={`pagination-num ${currentPage === i ? 'active' : ''}`}
            onClick={() => onPageChange(i)}
          >
            {i}
          </button>
        );
      }
    } else {
      // Always show first page
      pages.push(
        <button 
          key={1} 
          className={`pagination-num ${currentPage === 1 ? 'active' : ''}`}
          onClick={() => onPageChange(1)}
        >
          1
        </button>
      );

      if (currentPage > 3) {
        pages.push(<span key="dots-start" className="pagination-dots">...</span>);
      }

      // Show pages around current page
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        if (i > 1 && i < totalPages) {
          pages.push(
            <button 
              key={i} 
              className={`pagination-num ${currentPage === i ? 'active' : ''}`}
              onClick={() => onPageChange(i)}
            >
              {i}
            </button>
          );
        }
      }

      if (currentPage < totalPages - 2) {
        pages.push(<span key="dots-end" className="pagination-dots">...</span>);
      }

      // Always show last page
      pages.push(
        <button 
          key={totalPages} 
          className={`pagination-num ${currentPage === totalPages ? 'active' : ''}`}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </button>
      );
    }
    
    return pages;
  };

  return (
    <div className="custom-pagination-container">
      {showSummary && (
        <div className="pagination-summary">
          Showing <span>{startItem}</span> to <span>{endItem}</span> of <span>{totalItems}</span> items
        </div>
      )}
      
      <div className="pagination-controls">
        <button 
          className="pagination-nav-btn" 
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <ChevronLeft size={18} />
          <span className="nav-text">Previous</span>
        </button>
        
        <div className="pagination-numbers">
          {renderPageNumbers()}
        </div>
        
        <button 
          className="pagination-nav-btn" 
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <span className="nav-text">Next</span>
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
